function BlockTimeOptionsProvider() {

    const options = {
        showReasons: true,
        blockTimeDurations: [
            {
                label: '15 Minutes',
                value: 15
            },
            {
                label: '30 Minutes',
                value: 30
            },
            {
                label: '45 Minutes',
                value: 45
            },
            {
                label: '1 hour',
                value: 60
            },
            {
                label: '2 hours',
                value: 120
            },
            {
                label: '6 hours',
                value: 360
            },
            {
                label: '12 hours',
                value: 720
            }
        ]
    };

    this.setOption = function (option, value) {
        if (options.hasOwnProperty(option)) {
            options[option] = value;
        }
    };

    this.getOption = function (option) {
        if (options.hasOwnProperty(option)) {
            return options[option];
        }
    };

    this.$get = () => options;
}

/**
 * @ngdoc service
 * @module BB
 * @name BlockTimeOptionsProvider
 *
 * @description
 * Returns a set of Date/Time configuration options
 */
angular
    .module('BB')
    .provider('BlockTimeOptions', BlockTimeOptionsProvider);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/block_time_options.provider.js